import { render, staticRenderFns } from "./Responsible.vue?vue&type=template&id=6745a025&scoped=true&lang=html"
import script from "./Responsible.vue?vue&type=script&lang=js"
export * from "./Responsible.vue?vue&type=script&lang=js"
import style0 from "./Responsible.vue?vue&type=style&index=0&id=6745a025&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6745a025",
  null
  
)

export default component.exports